var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tournament.squad_size)?_c('span',[_c('span',{staticClass:"mx-1"},[_vm._v("•")]),_vm._v("\n  "+_vm._s(_vm.tournament.squad_size)+"vs"+_vm._s(_vm.tournament.squad_size)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }